import moment from 'moment';

const TimeUtils = {
  extractTime: date => {
    const t = moment(date).format('HH:mm');
    return t;
  },

  extractDate: date => {
    const d = moment(date).format('YYYY-MM-DD');
    return d;
  },

  combineDateNTime: (date, time) => {
    // time: hh:mm
    // const _time = _.split(time, ':')
    // const hour = _.head(_time)
    // const minute = _.last(_time)

    const strDate = moment(date).format('YYYY-MM-DD');
    // return moment(date).hour(hour).minute(minute).seconds(0).toDate()
    return strDate + ' ' + time;
  }
};
export default TimeUtils;
